(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name commons.directive:loadingPanel
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="commons">
     <file name="index.html">
     <loading-panel></loading-panel>
     </file>
     </example>
     *
     */
    angular
        .module('commons')
        .directive('loadingPanel', loadingPanel);

    function loadingPanel($templateRequest, $compile, EventManagerService) {
        return {
            restrict: 'EA',
            scope : true,
            replace: false,
            controllerAs: 'loadingPanel',
            controller: function ($scope) {
                var vm = this;
                vm.isLoadingVisible = false;
                vm.animationName = 'cube';
                EventManagerService.registerEventListener(EventManagerService.EVENT.SHOW_HIDE_LOADING, function onShowHideLoading(data) {
                    if(typeof data == 'object'){
                        if(!!data['target']){
                            if($scope.targetName == data['target']){
                                if(!!data['animationName']){
                                    vm.animationName = data['animationName'];
                                }else{
                                    vm.animationName = 'cube';
                                }
                                vm.isLoadingVisible = data['flag'];
                            }
                        }

                    }else{
                        if($scope.targetName == 'appLoading'){
                            vm.animationName = 'cube';
                            vm.isLoadingVisible = data;
                        }
                    }
                },true);
            },
            link: function (scope, element, attrs) {
                /* jshint unused:false */
                /* eslint "no-unused-vars": [2, {"args": "none"}] */
                var container = angular.element(element);

                scope.targetName = 'appLoading';
                if (!!attrs['loadingPanel']) {
                    scope.targetName = attrs['loadingPanel'];
                }

                $templateRequest('loading-panel-directive.tpl.html').then(
                    function (html) {
                        var tmp = $compile(html)(scope);
                        container.append(tmp);
                    }
                );
            }
        };
    }
}());
